import { useAuth } from '@/contexts/AuthContext';
import { Eye, X } from 'lucide-react';

export default function ImpersonationBanner() {
  const { isImpersonation, user } = useAuth();
  if (!isImpersonation) return null;

  const exit = () => {
    sessionStorage.clear();
    window.close();
    window.location.href = '/login';
  };

  const displayName = user?.shop_name || user?.owner_name || 'Store';

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between bg-orange-500 text-white text-sm px-4 py-2">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4 shrink-0" />
        <span>Viewing as <strong>{displayName}</strong> — admin debug session (2h)</span>
      </div>
      <button
        onClick={exit}
        className="flex items-center gap-1 hover:bg-orange-600 rounded px-2 py-1 transition-colors"
      >
        <X className="h-4 w-4" />
        Exit
      </button>
    </div>
  );
}
